import React from "react";
import { Container } from "semantic-ui-react";

const Preise = () => {
  return (
    <Container id="Preise" className="main_content">
      {/*<i className="ion-checkmark"> </i>*/}

      <h1>Preise</h1>
      <div className="snip1214">
        <div className="plan">
          <h3 className="plan-title">Eigenes Boot</h3>
          <div className="plan-cost">
            <span className="plan-price">20</span>
            <span className="plan-type">/ p.P p.T.</span>
          </div>
          <ul className="plan-features">
            <li>Nutzung der kompletten Anlage</li>
            <li>
              Slippen mit dem Krahn <br />50€ (Rein & Raus)
            </li>
          </ul>
        </div>
        <div className="plan">
          <h3 className="plan-title">Auslegeboot</h3>
          <div className="plan-cost">
            <span className="plan-price">150</span>
            <span className="plan-type">/ p.W.</span>
          </div>
          <ul className="plan-features">
            <lI>Samstag bis Samstag</lI>
            <lI>
              <b>10PS</b> Außenborder
            </lI>
            <lI>300cm Schlauchboot</lI>
          </ul>
        </div>
        <div className="plan">
          <h3 className="plan-title">Bootszelt</h3>
          <div className="plan-cost">
            <span className="plan-price">40</span>
            <span className="plan-type">/ p.W.</span>
          </div>
          <ul className="plan-features">
            <lI>Samstag bis Samstag</lI>
            <lI>für Leihboote</lI>
          </ul>
        </div>
      </div>

      <p>Boot-Benzin ( Aktueller Tankstellenpreis)</p>
      <p>Leihgerät auf Anfrage</p>

      <h1>Preise Waller-Welt Mittellauf</h1>
      <p>Am Mittellauf sind 2 Lizenzen zu 75€ im Jahr nötig.</p>
      <div className="snip1214">
        <div className="plan">
          <h3 className="plan-title">Klasse 1+</h3>
          <div className="plan-cost">
            <span className="plan-price">599</span>
            <span className="plan-type">/ p.P.</span>
          </div>
          <ul className="plan-features">
            <li>Samstag bis Samstag</li>
            <li>inkl. Einweisung durch einen Guide am Fluss</li>
            <li>Slippen vom Boot bei An und Abreise</li>
            <li>Steine für Steinmontage</li>
            <li>Nutzung der kompletten Anlage</li>
            <li>
              Bei 3 Personen <b>20% Rabatt</b> auf den Wochenpreis
            </li>
          </ul>
        </div>
        <div className="plan featured">
          <h3 className="plan-title">Klasse 1</h3>
          <div className="plan-cost">
            <span className="plan-price">449</span>
            <span className="plan-type">/ p.P.</span>
          </div>
          <ul className="plan-features">
            <li>Samstag bis Samstag</li>
            <li>inkl. Einweisung durch einen Guide am Fluss</li>
            <li>Slippen vom Boot bei An und Abreise</li>
            <li>Steine für Steinmontage</li>
            <li>Nutzung der kompletten Anlage</li>
            <li>
              Bei 3 Personen <b>20% Rabatt</b> auf den Wochenpreis
            </li>
          </ul>
        </div>
        <div className="plan">
          <h3 className="plan-title">Klasse 2</h3>
          <div className="plan-cost">
            <span className="plan-price">419</span>
            <span className="plan-type">/ p.P.</span>
          </div>
          <ul className="plan-features">
            <li>Samstag bis Samstag</li>
            <li>inkl. Einweisung durch einen Guide am Fluss</li>
            <li>Slippen vom Boot bei An und Abreise</li>
            <li>Steine für Steinmontage</li>
            <li>Nutzung der kompletten Anlage</li>
          </ul>
        </div>
      </div>
      <h1>Preise Guiding</h1>

      <div className="snip1214">
        <div className="plan">
          <h3 className="plan-title">5 Tage</h3>
          <div className="plan-cost">
            <span className="plan-price">999</span>
            <span className="plan-type">/ p.P.</span>
          </div>
          <ul className="plan-features">
            <li>Vollguiding</li>
            <li>6 Tage angeln</li>
            <li>inkl. Leihgerät</li>
          </ul>
        </div>
        <div className="plan">
          <h3 className="plan-title">2,5 Tage</h3>
          <div className="plan-cost">
            <span className="plan-price">555</span>
            <span className="plan-type">/ p.P.</span>
          </div>
          <ul className="plan-features">
            <li>Vollguiding</li>
            <li>inkl. Leihgerät</li>
          </ul>
        </div>
        <div className="plan">
          <h3 className="plan-title">1 Tag</h3>
          <div className="plan-cost">
            <span className="plan-price">200</span>
            <span className="plan-type">/ p.P.</span>
          </div>
          <ul className="plan-features">
            <li>Vollguiding</li>
            <li>inkl. Leihgerät</li>
          </ul>
        </div>
        <div className="plan featured">
          <h3 className="plan-title">Einführung</h3>
          <div className="plan-cost">
            <span className="plan-price">75</span>
            <span className="plan-type">/ p.P.</span>
          </div>
          <ul className="plan-features">
            <li>Einführungs-Guiding</li>
            <li>
              <b>nur für Leihboote</b>
            </li>
          </ul>
        </div>
      </div>

      <br />
    </Container>
  );
};

export default Preise;



// WEBPACK FOOTER //
// ./src/components/Preise/index.js